var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var badge = {
    display: 'inline-block',
    border: '1px solid transparent',
    color: '#ffffff',
    backgroundColor: '#666666',
    borderRadius: 12,
    fontWeight: '500',
    textAlign: 'center',
    boxSizing: 'border-box',
    verticalAlign: 'middle',
    fontSize: "".concat(12, "px !important"),
    lineHeight: "".concat(24 - 1, "px"),
    height: 24,
    padding: "0 ".concat(8, "px"),
};
export var compact = {
    borderRadius: '50%',
    height: 12,
    padding: 0,
    width: 12,
};
export var small = {
    fontSize: '11px !important',
    height: 16,
    lineHeight: "".concat(14, "px"),
    padding: "0 ".concat(4, "px"),
};
export var primary = __assign(__assign({}, badge), { backgroundColor: '#ff6611' });
export var secondary = __assign(__assign({}, badge), { backgroundColor: '#1588af' });
export var green = __assign(__assign({}, badge), { backgroundColor: '#2eab73' });
export var red = __assign(__assign({}, badge), { backgroundColor: '#c8102e' });
export var white = __assign(__assign({}, badge), { backgroundColor: '#ffffff', color: '#393939' });
export var outline = {
    backgroundColor: 'transparent',
    border: "1px solid ".concat('#a6a6a6'),
    color: '#666666',
};
export var outlinePrimary = __assign(__assign({}, outline), { border: "1px solid ".concat('#ff6611'), color: '#ff6611' });
export var outlineSecondary = __assign(__assign({}, outline), { border: "1px solid ".concat('#1588af'), color: '#1588af' });
export var outlineGreen = __assign(__assign({}, outline), { border: "1px solid ".concat('#2eab73'), color: '#2eab73' });
export var outlineRed = __assign(__assign({}, outline), { border: "1px solid ".concat('#c8102e'), color: '#c8102e' });
export var outlineWhite = __assign(__assign({}, outline), { color: '#ffffff', borderColor: '#ffffff' });
export var outlineNeutral = __assign(__assign({}, outline), { border: "1px solid ".concat('#666666'), color: '#666666' });
